export default __webpack_public_path__ + "static/media/1958.97edf14a.png";